/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BatchSessionCreditOperation,
    BatchSessionCreditOperationFromJSON,
    BatchSessionCreditOperationToJSON,
    ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    SessionCreditBalance,
    SessionCreditBalanceFromJSON,
    SessionCreditBalanceToJSON,
    SessionCreditBulkParams,
    SessionCreditBulkParamsFromJSON,
    SessionCreditBulkParamsToJSON,
} from '../models';

export interface FindBalanceForAttendeeSessionCreditBalanceRequest {
    program_id: string;
    program_attendee_id: string;
}

export interface FindBalanceForContactSessionCreditBalanceRequest {
    program_id: string;
    contact_id: string;
    program_attendee_id?: string;
}

export interface UndoVoidBulkSessionCreditBalanceRequest {
    program_id: string;
    contact_id: string;
    SessionCreditBulkParams: SessionCreditBulkParams;
}

export interface VoidBulkSessionCreditBalanceRequest {
    program_id: string;
    contact_id: string;
    SessionCreditBulkParams: SessionCreditBulkParams;
}

/**
 * 
 */
export class RegistrationApi extends runtime.BaseAPI {

    /**
     * Find session balance by id
     */
    async findBalanceForAttendeeSessionCreditBalanceRaw(requestParameters: FindBalanceForAttendeeSessionCreditBalanceRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SessionCreditBalance>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findBalanceForAttendeeSessionCreditBalance.');
        }

        if (requestParameters.program_attendee_id === null || requestParameters.program_attendee_id === undefined) {
            throw new runtime.RequiredError('program_attendee_id','Required parameter requestParameters.program_attendee_id was null or undefined when calling findBalanceForAttendeeSessionCreditBalance.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/attendees/{program_attendee_id}/session_balance`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"program_attendee_id"}}`, encodeURIComponent(String(requestParameters.program_attendee_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SessionCreditBalanceFromJSON(jsonValue));
    }

    /**
     * Find session balance by id
     */
    async findBalanceForAttendeeSessionCreditBalance(requestParameters: FindBalanceForAttendeeSessionCreditBalanceRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SessionCreditBalance> {
        const response = await this.findBalanceForAttendeeSessionCreditBalanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find session balance by id
     */
    async findBalanceForContactSessionCreditBalanceRaw(requestParameters: FindBalanceForContactSessionCreditBalanceRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SessionCreditBalance>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findBalanceForContactSessionCreditBalance.');
        }

        if (requestParameters.contact_id === null || requestParameters.contact_id === undefined) {
            throw new runtime.RequiredError('contact_id','Required parameter requestParameters.contact_id was null or undefined when calling findBalanceForContactSessionCreditBalance.');
        }

        const queryParameters: any = {};

        if (requestParameters.program_attendee_id !== undefined) {
            queryParameters['program_attendee_id'] = requestParameters.program_attendee_id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/contacts/{contact_id}/session_balance`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"contact_id"}}`, encodeURIComponent(String(requestParameters.contact_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SessionCreditBalanceFromJSON(jsonValue));
    }

    /**
     * Find session balance by id
     */
    async findBalanceForContactSessionCreditBalance(requestParameters: FindBalanceForContactSessionCreditBalanceRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SessionCreditBalance> {
        const response = await this.findBalanceForContactSessionCreditBalanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Undo void a session credit in bulk
     */
    async undoVoidBulkSessionCreditBalanceRaw(requestParameters: UndoVoidBulkSessionCreditBalanceRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<BatchSessionCreditOperation>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling undoVoidBulkSessionCreditBalance.');
        }

        if (requestParameters.contact_id === null || requestParameters.contact_id === undefined) {
            throw new runtime.RequiredError('contact_id','Required parameter requestParameters.contact_id was null or undefined when calling undoVoidBulkSessionCreditBalance.');
        }

        if (requestParameters.SessionCreditBulkParams === null || requestParameters.SessionCreditBulkParams === undefined) {
            throw new runtime.RequiredError('SessionCreditBulkParams','Required parameter requestParameters.SessionCreditBulkParams was null or undefined when calling undoVoidBulkSessionCreditBalance.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/contacts/{contact_id}/session_credits/undo_void`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"contact_id"}}`, encodeURIComponent(String(requestParameters.contact_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SessionCreditBulkParamsToJSON(requestParameters.SessionCreditBulkParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BatchSessionCreditOperationFromJSON(jsonValue));
    }

    /**
     * Undo void a session credit in bulk
     */
    async undoVoidBulkSessionCreditBalance(requestParameters: UndoVoidBulkSessionCreditBalanceRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<BatchSessionCreditOperation> {
        const response = await this.undoVoidBulkSessionCreditBalanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Void a session credit in bulk
     */
    async voidBulkSessionCreditBalanceRaw(requestParameters: VoidBulkSessionCreditBalanceRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<BatchSessionCreditOperation>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling voidBulkSessionCreditBalance.');
        }

        if (requestParameters.contact_id === null || requestParameters.contact_id === undefined) {
            throw new runtime.RequiredError('contact_id','Required parameter requestParameters.contact_id was null or undefined when calling voidBulkSessionCreditBalance.');
        }

        if (requestParameters.SessionCreditBulkParams === null || requestParameters.SessionCreditBulkParams === undefined) {
            throw new runtime.RequiredError('SessionCreditBulkParams','Required parameter requestParameters.SessionCreditBulkParams was null or undefined when calling voidBulkSessionCreditBalance.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/contacts/{contact_id}/session_credits/void`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"contact_id"}}`, encodeURIComponent(String(requestParameters.contact_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SessionCreditBulkParamsToJSON(requestParameters.SessionCreditBulkParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BatchSessionCreditOperationFromJSON(jsonValue));
    }

    /**
     * Void a session credit in bulk
     */
    async voidBulkSessionCreditBalance(requestParameters: VoidBulkSessionCreditBalanceRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<BatchSessionCreditOperation> {
        const response = await this.voidBulkSessionCreditBalanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
